/**
 * User role enum for role-based access control
 */
export enum UserRole {
  ADMIN = 'admin',
  INVESTOR = 'investor',
}

/**
 * User data model
 */
export interface User {
  id: string;
  email: string;
  displayName: string;
  role: UserRole;
  avatar?: string;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Auth response payload from backend
 */
export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  user?: User;
}

/**
 * Auth credentials for login/register
 */
export interface AuthCredentials {
  email: string;
  password: string;
}

/**
 * Register data
 */
export interface RegisterData {
  displayName: string;
  email: string;
  password: string;
}

/**
 * JWT payload (decoded)
 */
export interface JwtPayload {
  sub: string;
  email: string;
  role: UserRole;
  iat: number;
  exp: number;
}
